<cm-overlay
  [width]="1150"
  [height]="640"
  header="{{ 'MENU_CONFERENCING_TITLE' | translate }}"
  >
  @if (choices | async; as choices) {
    <cm-choice-selector
      [choices]="choices"
      (choiceSelected)="onChoiceSelected($event)"
      [columns]="1"
      [choiceWidth]="1000"
      [choiceHeight]="140"
      [showAvatar]="true"
      >
    </cm-choice-selector>
  } @else {
    <mat-spinner></mat-spinner>
  }
</cm-overlay>
